import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86ec9662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form__register" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Register", -1))
const _hoisted_4 = { class: "form__input--first" }
const _hoisted_5 = { class: "show-password" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "cbox2" }, "Mostrar contraseñas", -1))
const _hoisted_7 = { class: "form__btn--login" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_input = _resolveComponent("l-input")!
  const _component_l_buttom = _resolveComponent("l-buttom")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_l_input, {
          "onUpdate:input": _cache[0] || (_cache[0] = ($event: any) => (_ctx.user = $event)),
          pholder: "Ingrese su usuario",
          input: "text",
          id: "username",
          value: _ctx.user,
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.NextFocus('email_register')), ["enter"]))
        }, null, 8, ["value"]),
        _createVNode(_component_l_input, {
          "onUpdate:input": _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event)),
          pholder: "Ingrese su correo electronico",
          input: "email",
          value: _ctx.email,
          id: "email_register",
          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.NextFocus('remail')), ["enter"]))
        }, null, 8, ["value"]),
        _createVNode(_component_l_input, {
          "onUpdate:input": _cache[4] || (_cache[4] = ($event: any) => (_ctx.password = $event)),
          pholder: "Ingrese su contraseña",
          input: _ctx.type_pass,
          value: _ctx.password,
          id: "password_register",
          onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.NextFocus('rpassword')), ["enter"]))
        }, null, 8, ["input", "value"]),
        _createVNode(_component_l_input, {
          "onUpdate:input": _cache[6] || (_cache[6] = ($event: any) => (_ctx.rpassword = $event)),
          pholder: "Repita su contraseña",
          input: _ctx.type_pass,
          id: "rpassword",
          value: _ctx.rpassword,
          onKeyup: _withKeys(_ctx.sendData, ["enter"])
        }, null, 8, ["input", "value", "onKeyup"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("input", {
            onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showPass && _ctx.showPass(...args))),
            type: "checkbox",
            id: "cbox2",
            value: "second_checkbox"
          }, null, 32),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_l_buttom, {
          onClick: _ctx.sendData,
          text: _ctx.form__btn_text
        }, null, 8, ["onClick", "text"])
      ])
    ])
  ]))
}